import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { DASHBOARD_URL } from '../App';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '/connectors', label: 'Connectors' },
    { href: '/features', label: 'Features' },
    { href: '/pricing', label: 'Pricing' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 px-4 sm:px-6 lg:px-8 pt-4">
      <div
        className={`max-w-7xl mx-auto transition-all duration-300 ${
          scrolled
            ? 'bg-white/90 backdrop-blur-xl shadow-lg'
            : 'bg-white/80 backdrop-blur-xl'
        } rounded-2xl border border-gray-200/50`}
      >
        <div className="px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {/* Logo - Left */}
            <Link to="/" className="flex-shrink-0">
              <span className="text-xl font-bold">
                <span className="text-blue-600">Nexus</span>
                <span className="text-gray-900">ERP</span>
              </span>
            </Link>

            {/* Center Nav Links */}
            <div className="hidden md:flex items-center justify-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-gray-900 hover:text-blue-600 transition-colors font-medium"
                >
                  {link.label}
                </Link>
              ))}
            </div>

            {/* Right - Auth */}
            <div className="hidden md:flex items-center space-x-4">
              <a
                href={`${DASHBOARD_URL}/login`}
                className="text-gray-900 hover:text-blue-600 transition-colors font-medium"
              >
                Sign In
              </a>
              <a
                href={`${DASHBOARD_URL}/signup`}
                className="bg-gray-900 hover:bg-gray-800 text-white px-5 py-2 rounded-lg font-medium transition-colors"
              >
                Get Started
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6 text-gray-900" />
              ) : (
                <Menu className="h-6 w-6 text-gray-900" />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden py-4 border-t border-gray-200">
              <div className="flex flex-col space-y-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    onClick={() => setMobileMenuOpen(false)}
                    className="text-gray-900 hover:text-blue-600 hover:bg-gray-50 transition-colors font-medium px-4 py-3 rounded-lg"
                  >
                    {link.label}
                  </Link>
                ))}

                <div className="pt-4 mt-2 border-t border-gray-200 space-y-2">
                  <a
                    href={`${DASHBOARD_URL}/login`}
                    onClick={() => setMobileMenuOpen(false)}
                    className="block text-gray-900 hover:text-blue-600 transition-colors font-medium px-4 py-3 text-center"
                  >
                    Sign In
                  </a>
                  <a
                    href={`${DASHBOARD_URL}/signup`}
                    className="block bg-gray-900 text-white px-4 py-3 rounded-lg font-medium text-center"
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
